import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Contact from "./pages/Contact";
import Resources from "./pages/Resources";
import Admin from "./pages/Admin";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Sitemap from "./pages/Sitemap";
import { Toaster } from "./components/ui/toaster";
import { DataProvider } from "./DataContext";
import { VendorAuthProvider } from "./vendor/VendorAuthContext";
import VendorLayout from "./vendor/VendorLayout";
import VendorLogin from "./vendor/VendorLogin";
import VendorDashboard from "./vendor/VendorDashboard";
import VendorPOList from "./vendor/VendorPOList";
import VendorPODetail from "./vendor/VendorPODetail";
import VendorProfile from "./vendor/VendorProfile";
import VendorSubmitInvoice from "./vendor/VendorSubmitInvoice";
import VendorInvoices from "./vendor/VendorInvoices";
import VendorDocuments from "./vendor/VendorDocuments";
import { CustomerAuthProvider } from "./customer/CustomerAuthContext";
import CustomerLayout from "./customer/CustomerLayout";
import CustomerLogin from "./customer/CustomerLogin";
import CustomerDashboard from "./customer/CustomerDashboard";
import CustomerProfile from "./customer/CustomerProfile";
import CustomerSalesDocuments from "./customer/CustomerSalesDocuments";
import CustomerStatement from "./customer/CustomerStatement";
import { SEOManager } from "./hooks/usePageMeta";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function ChromeOrVendor() {
  const { pathname } = useLocation();
  const isVendor = pathname === "/vendor" || pathname.startsWith("/vendor/");
  const isCustomer = pathname === "/customer" || pathname.startsWith("/customer/");
  const hideChrome = isVendor || isCustomer;
  return (
    <>
      <SEOManager />
      {!hideChrome && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/vendor/login" element={<VendorLogin />} />
          <Route path="/vendor" element={<VendorLayout />}>
            <Route index element={<VendorDashboard />} />
            <Route path="pos" element={<VendorPOList />} />
            <Route path="pos/:id" element={<VendorPODetail />} />
            <Route path="submit-invoice" element={<VendorSubmitInvoice />} />
            <Route path="invoices" element={<VendorInvoices />} />
            <Route path="documents" element={<VendorDocuments />} />
            <Route path="profile" element={<VendorProfile />} />
          </Route>
          <Route path="/customer/login" element={<CustomerLogin />} />
          <Route path="/customer" element={<CustomerLayout />}>
            <Route index element={<CustomerDashboard />} />
            <Route path="sales-documents" element={<CustomerSalesDocuments />} />
            <Route path="statement" element={<CustomerStatement />} />
            <Route path="profile" element={<CustomerProfile />} />
          </Route>
        </Routes>
      </main>
      {!hideChrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App bg-white text-slate-900 font-sans">
      <DataProvider>
        <VendorAuthProvider>
          <CustomerAuthProvider>
            <BrowserRouter>
              <ScrollToTop />
              <ChromeOrVendor />
              <Toaster />
            </BrowserRouter>
          </CustomerAuthProvider>
        </VendorAuthProvider>
      </DataProvider>
    </div>
  );
}

export default App;
